export default "__VITE_ASSET__B$o$BTCb__"